import { SxProps } from '@mui/material';

export const catalogEntryListCompareCollectorBarSX: SxProps = {
	width: 'inherit',
	maxWidth: '1440px',
	backgroundColor: 'white',
	'div.MuiGrid-item': {
		display: 'flex',
		alignItems: 'center',
	},
};
